import { Grid, Button, Dialog, DialogContent, DialogContentText, DialogTitle, DialogActions } from '@material-ui/core'
import React from 'react'
import { useState } from 'react'
import ActiveUserManagement from './ActiveUserManagement'
import AddHeaderDescriptionWithHelperText from '../../components/HelperTextDescription'
import ProvisionUserManagement from './ProvisionUserManagement'
import { useSelector, connect } from 'react-redux'

const UserManagement = (props) => {
  const [view,setView]=useState("activeUserManagement")
  
  return (
    <Grid container>
      <Grid item xs={12}>
        <AddHeaderDescriptionWithHelperText
          header={`User Management`}
          description={`Provision new SkyGeni users, deactivate or reactivate existing users`}
        />
        </Grid>
        {view === "activeUserManagement" &&  <Grid container>
          <ActiveUserManagement
          setView={setView}
          />
        </Grid>}

        {view === "provisionUsersManagement" &&  <Grid container>
          {/* <Button
            variant="outlined"
            style={{margin: '16px 0 0 16px'}}
            onClick={() => setView('activeUserManagement')}
          >
            Back
          </Button> */}
          <ProvisionUserManagement setView={setView}/>
        </Grid>}
         <Dialog
                open={props.isUserInvited && props.inviteEmail!==""}
                onClose={() => props.clearSuccess()}
                aria-labelledby="user-created-success-title"
                aria-describedby="user-created-success-description"
              >
                <DialogTitle id="user-created-success-title">
                 User Provisioned Successfully
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="user-created-success-description">
                    User has been provisioned with email <strong>{props.inviteEmail}</strong>.<br /><br />
                    A temporary password has been sent to their email. Upon first login, they will be required to change their password.
                  </DialogContentText>
                </DialogContent>
                <DialogActions style={{ justifyContent: 'center', paddingBottom: '1.5rem' }}>
                  <Button
                    onClick={() => props.clearSuccess()}
                    color="primary"
                    variant="contained"
                    autoFocus
                  >
                    OK
                  </Button>
                </DialogActions>
              </Dialog>

    </Grid>
  )
}
const mapStateToProps = (state) => {
  const { isUserInvited, inviteEmail } = state.app;
  return {
    isUserInvited,
    inviteEmail
  };
};
const mapDispatchToProps = (dispatch) => ({
  clearSuccess: () => {
    dispatch({ type: "clear_invite_success" });
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(UserManagement);